// Note : this file consists of all services that will call out to external services
// if this is being ran in production / staging, then they will follow the urls below
// if this is being ran from development (localhost), then this will read the .env
// variables and follow the variables
// Note that test == staging

// production
// jetpac-sim       https://orbit-sim.circles.life
// jetpac-pay       https://api.jetpacglobal.com
// jetpac-reward    https://orbit-api.circles.life
// jetpac-catalog   https://orbit-api.circles.life
// orbit-pay        https://orbit-api.circles.life
// orbit            https://orbit-api.circles.life

// staging
// jetpac-sim       https://ssg-orbit-sim.circleslife.co
// jetpac-pay       https://ssg-orbit-api.circleslife.co
// jetpac-reward    https://ssg-orbit-api.circleslife.co
// jetpac-catalog   https://ssg-orbit-api.circleslife.co
// orbit-pay        https://ssg-orbit-api.circleslife.co
// orbit            https://ssg-orbit-api.circleslife.co

let environment = 'production'
if (!window.location.hostname.includes('engine.jetpacglobal.com')) {
  if (process.env.NODE_ENV === 'development') {
    environment = 'development'
  } else {
    environment = 'test'
  }
}

export const generateJetpacSimHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://orbit-sim.circles.life'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-sim.circleslife.co'
      break
    // if in development mode, we can conditionally switch backends to test
    // Local
    case 'development':
      hostname = process.env.REACT_APP_DEV_JETPAC_SIM
      break
    default:
      break
  }

  return hostname
}

export const generateJetpacPayHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://api.jetpacglobal.com'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-api.circleslife.co'
      break
    // if in development mode, this will hit localhost
    case 'development':
      hostname = process.env.REACT_APP_DEV_JETPAC_PAY
      break
    default:
      break
  }
  return hostname
}

export const generateJetpacRewardHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://orbit-api.circles.life'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-api.circleslife.co'
      break
    case 'development':
      hostname = process.env.REACT_APP_DEV_JETPAC_REWARD
      break
    default:
      break
  }
  return hostname
}

export const generateJetpacCatalogHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://orbit-api.circles.life'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-api.circleslife.co'
      break
    // if in development mode, this will hit localhost
    case 'development':
      hostname = process.env.REACT_APP_DEV_JETPAC_CATALOG
      break
    default:
      break
  }
  return hostname
}

export const generateOrbitPayHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://orbit-api.circles.life'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-api.circleslife.co'
      break
    // if in development mode, this will hit localhost
    case 'development':
      hostname = process.env.REACT_APP_DEV_ORBIT_SIM
      break
    default:
      break
  }
  return hostname
}

export const generateOrbitHostname = () => {
  let hostname
  switch (environment) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      hostname = 'https://orbit-api.circles.life'
      break
    // Staging
    case 'test':
      hostname = 'https://ssg-orbit-api.circleslife.co'
      break
    // if in development mode, this will hit localhost
    case 'development':
      hostname = process.env.REACT_APP_DEV_ORBIT
      break
    default:
      break
  }
  return hostname
}

export const generateJetpacB2BHostname = () => {
  let hostname
  switch (environment) {
    case 'production':
      hostname = 'https://nlb-us-west-2.jetpacglobal.com'
      break
    case 'test':
      hostname = 'https://nlb-ap-southeast-1.jetpacstaging.com'
      break
    case 'development':
      hostname = process.env.REACT_APP_DEV_ORBIT_B2B
      break
    default:
      break
  }
  return hostname
}
